module.exports = __webpack_public_path__ + "static/media/Jubel-Medium.3df2333e.woff";